import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import Sidebar from 'components/Sidebar';
import SearchOverlay from 'components/SearchOverlay';
import MobileHeader from 'components/MobileHeader';
import {
    CompanyMappingChat,
    CompanyMappingMatrix,
    CompanyMappingIdeasList,
    CompanyMappingToolbar,
    AddIdeaPopup,
    IdeaDetailPopup,
    SharePopup
} from 'components/CompanyMapping';
import { getIdeas } from 'api/companyMapping';

export default function CompanyMapping() {
    const { conversationId } = useParams();

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);
    const [addPopup, setAddPopup] = useState(false);
    const [editingIdea, setEditingIdea] = useState(null);
    const [detailPopup, setDetailPopup] = useState(false);
    const [selectedIdea, setSelectedIdea] = useState(null);
    const [sharePopup, setSharePopup] = useState(false);

    // Fetch ideas from backend for this conversation
    const { data: ideas = [] } = useQuery({
        queryKey: ['company-mapping-ideas', conversationId],
        queryFn: () => getIdeas({ conversationId }),
        enabled: !!conversationId,
        retry: false
    });


    const handlePopupClose = (visible) => {
        setAddPopup(visible);
        if (!visible) {
            setEditingIdea(null);
        }
    };

    const handleViewDetail = (idea) => {
        setSelectedIdea(idea);
        setDetailPopup(true);
    };

    const handleDetailPopupClose = (visible) => {
        setDetailPopup(visible);
        if (!visible) {
            setSelectedIdea(null);
        }
    };

    return (
        <>
            <Sidebar visible={sidebar} setVisible={setSidebar} />
            <SearchOverlay visible={search} setVisible={setSearch} />
            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                setSearch={setSearch}
                search={search}
            />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                {/* Main container with split layout */}
                <div className="flex flex-col lg:flex-row h-[100svh] pt-14 lg:pt-0">

                    {/* Left Panel - Chat */}
                    <div className="w-full lg:w-[40%] h-[50vh] lg:h-full border-b lg:border-b-0 lg:border-r border-black/10 flex flex-col">
                        <CompanyMappingChat />
                    </div>

                    {/* Right Panel - Matrix & Ideas List */}
                    <div className="w-full lg:w-[60%] h-[50vh] lg:h-full overflow-y-auto">
                        <div className="p-6">
                            {/* Header */}
                            <div className='mb-6 flex justify-between'>
                                {/* <div className="">
                                    <h1 className="text-2xl font-bold text-black/90 mb-1">
                                        Matrice di Priorità
                                    </h1>
                                    <p className="text-sm text-black/50">
                                        Visualizzazione basata su <span className="text-black/70">Impatto Aziendale</span> vs <span className="text-black/70">Facilità d&apos;Uso</span>
                                    </p>
                                </div> */}

                                {/* Toolbar */}
                                <CompanyMappingToolbar
                                    ideas={ideas}
                                    onAddManual={() => {
                                        setEditingIdea(null);
                                        setAddPopup(true);
                                    }}
                                    onExport={() => setSharePopup(true)}
                                />
                            </div>

                            {/* Matrix Chart */}
                            <div className="bg-black/[0.02] rounded-xl p-4 mb-8">
                                <CompanyMappingMatrix
                                    ideas={ideas}
                                    onSelectIdea={handleViewDetail}
                                />
                            </div>

                            {/* Ideas List */}
                            <div>
                                {/* <h2 className="text-xl font-semibold text-black/90 mb-4">
                                    Dettaglio Idee
                                </h2> */}
                                <div className="bg-white border border-black/10 rounded-xl overflow-hidden">
                                    <CompanyMappingIdeasList
                                        ideas={ideas}
                                        onViewDetail={handleViewDetail}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add/Edit Popup */}
            <AddIdeaPopup
                visible={addPopup}
                setVisible={handlePopupClose}
                editingIdea={editingIdea}
            />

            {/* Detail Popup */}
            <IdeaDetailPopup
                visible={detailPopup}
                setVisible={handleDetailPopupClose}
                idea={selectedIdea}
            />

            {/* Share Popup */}
            <SharePopup
                visible={sharePopup}
                setVisible={setSharePopup}
            />
        </>
    );
}
